// @flow
import React from 'react';

import { PRODUCT_STREET_VIEW } from 'Client/cms/toolkit/constants';
import { ProductGoogleStreetViewLine } from 'Components/lines/product-google-street-view-line/ProductGoogleStreetViewLine.jsx';
import { productGoogleStreetViewResolver } from './productGoogleStreetView.resolver';

export const productGoogleStreetViewDescriptor = {
  name: PRODUCT_STREET_VIEW,
  component: ProductGoogleStreetViewLine,
  resolve: productGoogleStreetViewResolver.resolve,
};
